var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgS1B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51 25.5C51 39.5831 39.5831 51 25.5 51C11.4183 51 0 39.5831 0 25.5C0 11.4183 11.4183 0 25.5 0C39.5831 0 51 11.4183 51 25.5Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2917 29.0436C18.2477 29.0436 19.8333 26.8237 19.8333 24.0853C19.8333 21.3469 18.2477 19.127 16.2917 19.127C14.3357 19.127 12.75 21.3469 12.75 24.0853C12.75 26.8237 14.3357 29.0436 16.2917 29.0436Z",
    fill: "#664500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7057 29.0436C36.6617 29.0436 38.2474 26.8237 38.2474 24.0853C38.2474 21.3469 36.6617 19.127 34.7057 19.127C32.7497 19.127 31.1641 21.3469 31.1641 24.0853C31.1641 26.8237 32.7497 29.0436 34.7057 29.0436Z",
    fill: "#664500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49721 19.126C8.20254 19.126 7.90363 19.0339 7.64863 18.8426C7.02246 18.3737 6.89638 17.4855 7.36529 16.8593C11.9865 10.6968 18.1546 10.626 18.4153 10.626C19.1973 10.626 19.832 11.2606 19.832 12.0426C19.832 12.8232 19.2015 13.4565 18.421 13.4593C18.2014 13.4621 13.3663 13.5811 9.63196 18.5593C9.35429 18.9305 8.92788 19.126 8.49721 19.126ZM42.5 19.126C42.068 19.126 41.6444 18.9305 41.3653 18.5593C37.6239 13.5712 32.7789 13.4607 32.5735 13.4593C31.7943 13.4508 31.1653 12.8133 31.1695 12.0356C31.1738 11.255 31.8028 10.626 32.582 10.626C32.8426 10.626 39.0094 10.6968 43.632 16.8593C44.1023 17.4855 43.9748 18.3737 43.3486 18.8426C43.0936 19.0339 42.7961 19.126 42.5 19.126ZM33.269 40.2046C33.2535 40.1422 31.647 34.001 25.4986 34.001C19.3503 34.001 17.7438 40.1422 17.7282 40.2046C17.6531 40.5063 17.7905 40.8151 18.0569 40.9752C18.3232 41.1339 18.6703 41.0971 18.9012 40.8902C18.914 40.8789 20.3363 39.6676 25.4986 39.6676C30.5845 39.6676 32.0394 40.8435 32.0946 40.8902C32.2292 41.0177 32.4049 41.0843 32.582 41.0843C32.701 41.0843 32.8214 41.0546 32.9305 40.9936C33.2081 40.835 33.347 40.5134 33.269 40.2046Z",
    fill: "#664500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6647 43.9157C22.6647 47.8285 19.4942 50.999 15.5814 50.999C11.6685 50.999 8.49805 47.8285 8.49805 43.9157C8.49805 40.0029 14.1647 29.749 15.5814 29.749C16.998 29.749 22.6647 40.0029 22.6647 43.9157Z",
    fill: "#5DADEC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS1B);
export default __webpack_public_path__ + "static/media/s1b.ced41346c9c41acdf13b201b8778e914.svg";
export { ForwardRef as ReactComponent };